import "./VideoTutorial.scss";
import React, { useEffect, useState } from "react";
import { MdHelpOutline } from "react-icons/md";
import { Button, ButtonType } from "../Components/Button/Button";
import VideoTutorialTray from "./VideoTutorialTray";
import { VideoInfo } from "./videoTutorialUtils";

interface VideoTutorialProps {
  showHelpButton: boolean;
  videoList: VideoInfo[] | undefined;
}

const VideoTutorial: React.FC<VideoTutorialProps> = ({ showHelpButton, videoList }) => {
  const [showVideoTray, setShowVideoTray] = useState<boolean>(false);
  const [videoContentList, setVideoContentList] = useState<VideoInfo[]>([]);

  useEffect(() => {
    if (videoList) {
      setVideoContentList(videoList);
    }
  }, [videoList]);

  const helpButtonView = (
    <div className="buttonContainer">
      <Button
        className="helpPillButton"
        size="lg"
        type={ButtonType.FILLED}
        icon={<MdHelpOutline className="helpButtonQuestionIcon" />}
        title="Help"
        onClick={() => setShowVideoTray(true)}
      />
    </div>
  );

  return (
    <div>
      {showHelpButton && helpButtonView}
      <VideoTutorialTray
        showVideoTray={showVideoTray}
        setShowVideoTray={setShowVideoTray}
        videoList={videoContentList}
      />
    </div>
  );
};

export default VideoTutorial;
